/* src/app/global/components/global-help/global-help-text/global-help-text.component.scss */
:host h2 {
  overflow: hidden;
  overflow-wrap: break-word;
}
:host .error {
  color: var(--color-accent);
  margin-bottom: 10px;
}
/*# sourceMappingURL=global-help-text.component.css.map */
